export enum ResourceType {
  ClinicalCodeList,
  DrugList,
  TestPerson,
  SessionHolderList,
  TestProposal,
  Rule,
  Parameter,
  KeyValuesList,
  GenericCodeList,
  GenericDrugList,
  GenericEthnicList
}
